import { render, staticRenderFns } from "./custom-grid-view-simple.vue?vue&type=template&id=0b0b1125&scoped=true&"
import script from "./custom-grid-view-simple.vue?vue&type=script&lang=js&"
export * from "./custom-grid-view-simple.vue?vue&type=script&lang=js&"
import style0 from "./custom-grid-view-simple.vue?vue&type=style&index=0&id=0b0b1125&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0b1125",
  null
  
)

export default component.exports